export const groupOfficersByRole = (officerwiseBreakdown) => {
    let allowedRoles = ["BM", "BCM", "RO"];

    let groupedOfficers = officerwiseBreakdown?.reduce((grp, officer) => {
        if (allowedRoles.includes(officer.role_code)){
            grp.find((role) => role.role === officer.role_code).officers.push(officer)
        }

        return grp;
    }, [
        {
            role: "BM",
            officers: []
        },
        {
            role: "BCM",
            officers: []
        },
        {
            role: "RO",
            officers: []
        },
    ]);

    return groupedOfficers;
}


// const groupOfficersByRole = () => {
//     const result = {
//         RO: {},
//         BM: {},
//         BCM: {},
//     };

//     const stageBreakdown =
//         branchwiseApplicationsList?.application_stage_breakdown || {};

//     Object.entries(stageBreakdown).forEach(([stageKey, stageData]) => {
//         const stageName =
//             stageData?.applications?.[0]?.parent_stage_name || stageKey;

//         stageData?.applications?.forEach((app) => {
//             const officers = [
//                 {
//                     role: "RO",
//                     officer: app.ro,
//                 },
//                 {
//                     role: "BM",
//                     officer: app.bm,
//                 },
//                 {
//                     role: "BCM",
//                     officer: app.bcm,
//                 },
//             ];

//             officers.forEach(({ role, officer }) => {
//                 if (!officer?.officer_id) return;

//                 if (!result[role][officer.officer_id]) {
//                     result[role][officer.officer_id] = {
//                         officer_id: officer.officer_id,
//                         officer_name: `${officer.first_name} ${officer.last_name}`.trim(),
//                         emp_id: officer.emp_id,
//                         total: 0,
//                         stage_counts: {},
//                     };
//                 }

//                 const officerRecord = result[role][officer.officer_id];

//                 officerRecord.total += 1;

//                 if (!officerRecord.stage_counts[stageName]) {
//                     officerRecord.stage_counts[stageName] = {
//                         stage_name: stageName,
//                         count: 0,
//                         application_ids: [],
//                     };
//                 }

//                 officerRecord.stage_counts[stageName].count += 1;
//                 officerRecord.stage_counts[stageName].application_ids.push(
//                     app.application_id
//                 );
//             });
//         });
//     });

//     return Object.fromEntries(
//         Object.entries(result).map(([role, officers]) => [
//             role,
//             Object.values(officers).map((officer) => ({
//                 ...officer,
//                 stage_counts: Object.values(officer.stage_counts),
//             })),
//         ])
//     );
// };